import React from 'react';
import ReactDOM from 'react-dom';
import App from '../src/app/App.tsx';
import './styles/index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
